import { Component } from '@angular/core';

import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'df-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  constructor(
    private _user: UserService,
    private _auth: AuthService
  ) { }

  avatar() {
    return this._user.getPhotoUrl();
  }

  personalInfo() {
    window.location.href = '/account/personal-info';
  }

  logout() {
    this._auth.logout();
    window.location.href = '/';
  }
}
